//Login Logos

//Home Logos
import elementalSvg from "../assets/image/secondary_logo.svg";
import { Tenant } from "../App";
import { Image } from "antd";

export const setLoginLogo = () => {
	switch (Tenant) {
		case "elemental":
			return (
				<img
					className="company-logo"
					style={{ width: "200px", position: "relative", left: "-10px" }}
					src={undefined}
					alt="Logo"
				/>
			);
		default:
			return null;
	}
};

export const setHomeLogo = () => {
	switch (Tenant) {
		case "elemental":
			return (
				<Image
					preview={false}
					width={"35px"}
					className="home-logo"
					src={elementalSvg}
					alt="Logo"
				/>
			);

		default:
			return <></>;
	}
};

export const setDrawerlogo = (logo_link: any) => {
	if (logo_link) {
		return (
			<img
				className="drawer-logo"
				style={{ width: "90px", marginTop: "5px" }}
				src={logo_link}
				alt="Drawer_logo"
			/>
		);
	} else {
		return <></>;
	}
};
